import React from 'react';
import { AppPages, navigate } from '../../common/routing/app-navigator';

export default function useAccordion(
  expandedCallback?: () => void,
): [
  number | string | boolean,
  (
    panel: number | string,
    queryParamsString?: string,
  ) => (_event: React.SyntheticEvent, newExpanded: boolean) => void,
  React.Dispatch<React.SetStateAction<number | string | boolean>>,
] {
  const [expanded, setExpanded] = React.useState<number | string | boolean>(
    false,
  );
  const handleChange =
    (panel: number | string, queryParamsString?: string) =>
    (event: React.SyntheticEvent, newExpanded: boolean) => {
      const checkbox =
        (event.target as HTMLInputElement).type === 'checkbox' ||
        ['LI', 'UL'].includes(
          ((event.target as HTMLElement).parentNode as HTMLElement).nodeName,
        );
      const checkParentNode =
        ((event.target as HTMLElement).parentNode as HTMLElement).id ===
        'menu-policy-severity-box';

      if (checkbox || checkParentNode) {
        return;
      }
      if (newExpanded && expandedCallback) {
        expandedCallback();
      }

      setExpanded(newExpanded ? panel : false);
      newExpanded &&
        queryParamsString &&
        navigate(AppPages.Policies, queryParamsString);
      //console.log('navigate called');
    };

  return [expanded, handleChange, setExpanded];
}
